"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1DeleteUser = void 0;
exports.v1DeleteUserSetMock = v1DeleteUserSetMock;
exports.v1DeleteUser = v1DeleteUser;
exports.useMutationV1DeleteUser = useMutationV1DeleteUser;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1DeleteUserSetMock(mock) {
    setMock = mock;
}
async function v1DeleteUser(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/cockatoo/v1/user`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((params.forceStatusCheck) && (await (0, is_down_1.cockatooIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'DELETE', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1DeleteUser = 'cockatoo:v1DeleteUser:delete';
function useMutationV1DeleteUser(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyV1DeleteUser }, mutationOptions));
}
function mutationFn({ params }) {
    const promise = v1DeleteUser(params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-delete-user.js.map